import { render, staticRenderFns } from "./LinkDigiBoards.vue?vue&type=template&id=71c1b92f&scoped=true"
import script from "./LinkDigiBoards.vue?vue&type=script&lang=js"
export * from "./LinkDigiBoards.vue?vue&type=script&lang=js"
import style0 from "./LinkDigiBoards.vue?vue&type=style&index=0&id=71c1b92f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c1b92f",
  null
  
)

export default component.exports